'use strict';
module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/is-obj/index.js
// module id = 107
// module chunks = 0 1 2 3 4 5 6 7 8 28